export default __webpack_public_path__ + "static/media/trustOption.ae947d56.png";